module.exports = __webpack_public_path__ + "img/620-42dfb3.png";